import { useSelector } from "react-redux";
import { RootState } from "../../../../store/index.js";
import { ACTION_TYPE_ATTRIBUTES, ACTION_TYPE_STOCK } from "../../../../../constants/actionTypes.js";
import StockTypeAndOptions from "./components/StockTypeAndOptions/StockTypeAndOptions.js";
import AttributesTypeAndOptions from "./components/AttributesTypeAndOptions/AttributesTypeAndOptions.js";
import CollectionChangeConfirmModal from "../../../modals/CollectionChangeConfirmModal/CollectionChangeConfirmModal.js";
import { useAppSelector } from "../../../../hooks/redux.js";

const TypeAndOptions = () => {
  const actionData = useAppSelector((state) => state.action.actionData);

  return (
    <>
      {actionData.type === ACTION_TYPE_STOCK && <StockTypeAndOptions />}
      {actionData.type === ACTION_TYPE_ATTRIBUTES && <AttributesTypeAndOptions />}
      <CollectionChangeConfirmModal />
    </>
  );
};

export default TypeAndOptions;